import styled from "styled-components";
import spacing from "theme/spacing.module.scss";
import colors from "theme/colors.module.scss";
import borders from "theme/borders.module.scss";
import { Button, Card } from "antd";

export const Container = styled.div`
  padding: ${spacing.spacingMD};
  border-radius: ${borders.borderRadiusSM};
  min-height: 200px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
`;

export const HeaderCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  justify-content: center;
`;

export const DateLabel = styled.div`
  font-size: 18px;
  font-weight: 600;
  text-transform: lowercase;
`;

export const SmallCard = styled(Card)<{ color?: string }>`
  background: ${colors.translucentPurple2};
  border: 1px solid ${colors.primaryPurple100};
  border-radius: ${borders.borderRadiusSM};
  .ant-card-body {
    padding: ${spacing.spacingSM};
  }
  margin-top: ${spacing.spacingSM};
  background-color: ${({ color }) => colors[color]};
`;

export const DatePickerAnchor = styled.div`
  position: relative;

  .hidden-date-picker {
    position: absolute;
    width: 0;
    opacity: 0;
    pointer-events: none;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const CalendarButton = styled(Button)`
  svg path {
    fill: #fff;
  }
`;

export const AvailableDot = styled.span`
  display: block;
  width: 16px;
  height: 2px;
  border-radius: 1px;
  background: ${colors.accentSuccess500};
  margin: 2px auto 0;
`;
